import { Text } from '@wix/design-system';
import { Ellipsis } from '@wix/package-picker-components';
import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';
import { Trans } from 'react-i18next';
import { AdvancedPlansFeature } from 'types';
import { getAdVoucherTransParams, getDomainName } from 'utils';
import s from '../Cycles/Cycles.scss';

interface MissingFeaturesListProps extends InjectedExperimentsProps {
  missingFeatures: AdvancedPlansFeature[];
  rootStore: RootStore;
}

const MissingFeaturesListComp: React.FC<MissingFeaturesListProps> = ({
  missingFeatures,
  rootStore,
  experiments,
}) => {
  const { amountToSpend, amount, currencyCode } =
    rootStore.appStore.googleVoucherAmounts;
  const domainName = getDomainName(experiments.all());
  const [currencyToString] = usePremiumCurrencyFormatter({
    currencyCode,
  });
  const voucherTransParams = getAdVoucherTransParams(
    currencyToString,
    amount,
    amountToSpend,
  );
  const domainFeatureTransParams = {
    domain: domainName,
    domainName,
  };

  const transParams = { ...voucherTransParams, ...domainFeatureTransParams };
  const translationTags = {
    b: <b />,
    ellipsis: (
      <Ellipsis
        dataHook='truncated-domain-name'
        text={domainName ?? ''}
        componentProps={{
          weight: 'bold',
          size: 'small',
        }}
      />
    ),
  };

  return (
    <Text
      tagName='div'
      weight='normal'
      size='small'
      className={s.missingFeaturesList}
    >
      <ul>
        {missingFeatures.map((feature, index) => (
          <li key={index} data-hook='monthly-disclaimer-missing-feature'>
            <div className={s.xMark} />
            <Trans
              i18nKey={feature.translationKey}
              components={translationTags}
              values={transParams}
            />
          </li>
        ))}
      </ul>
    </Text>
  );
};

export const MissingFeaturesList = withExperiments(
  withInjectedRootStore(MissingFeaturesListComp),
);
